import type { FieldSettingProps } from './types';

import { AlternativeLoadingSetting } from './alternative-loading-setting';
import { CloudProxySetting } from './cloud-proxy-setting';
import { ExcludedIPsSetting } from './excluded-ips-setting';
import { ExternalPageScriptSetting } from './external-page-script';
import { GdprCookieSetting } from './gdpr-cookie-setting';
import { GoogleAnalyticsDataSetting } from './google-analytics-data-setting';
import { GoogleAnalyticsTrackingSetting } from './google-analytics-tracking-setting';
import { PublicCheckerSetting } from './public-checker-setting';

export const fields: Record<
	string,
	( props: FieldSettingProps ) => JSX.Element | null
> = {
	AlternativeLoadingSetting,
	CloudProxySetting,
	ExcludedIPsSetting,
	ExternalPageScriptSetting,
	GdprCookieSetting,
	GoogleAnalyticsDataSetting,
	GoogleAnalyticsTrackingSetting,
	PublicCheckerSetting,
};
